import { ReactNode, useEffect, useState } from "react"
import { Socket } from "socket.io-client"
import { useAppDispatch, useAppSelector } from "../../redux/store/hooks"
import { selectProfessionalUser } from "../../redux/ProfessionalAuthentication"
import notNull from "../../util/notNull"
import initSocket from "./initSocket"
import OnMedicationMatrixScannedEvent from "../OnMedicationMatrixScannedEvent"
import OnLinkingRequestArrivedEvent from "../OnLinkingRequestArrivedEvent"
import onValueTypeArrivedEvent from "../OnValueTypeArrivedEvent"
import OnAnalysisMessageReadyEvent from "../OnAnalysisMessageReadyEvent"
import {
    selectDashboardSelectedPatient,
    selectDashboardSelectedValueType
} from "../../redux/ProfessionalDashboard"
import { SocketEventInputs } from "./SocketEvent"
import {
    OnLinkingRequestArrivedEventKey,
    OnMedicationMatrixScannedEventKey,
    OnValueArrivedEventKey,
    OnAnalysisMessageReadyEventKey
} from "pokal_api"

interface SocketControllerProps {
    children: ReactNode
}

function SocketController(props: SocketControllerProps) {
    const professional = useAppSelector(selectProfessionalUser)
    const [socket, setSocket] = useState<Socket | null>(null)

    const [input, setInput] = useState<SocketEventInputs>({
        currentlySelectedPatient: null,
        currentlySelectedValueType: null
    })
    const selectedPatient = useAppSelector(selectDashboardSelectedPatient)
    const selectedValueType = useAppSelector(selectDashboardSelectedValueType)

    useEffect(() => {
        setInput({
            currentlySelectedPatient: selectedPatient?.id ?? null,
            currentlySelectedValueType: selectedValueType ?? null
        })
    }, [selectedPatient, selectedValueType])

    const dispatch = useAppDispatch()

    useEffect(() => {
        if (notNull(professional)) {
            setSocket(initSocket())
        } else {
            setSocket(null)
        }
    }, [professional])

    useEffect(() => {
        if (!notNull(socket)) return
        try {
            socket.off(OnMedicationMatrixScannedEventKey)
            socket.off(OnLinkingRequestArrivedEventKey)
            socket.off(OnValueArrivedEventKey)
            socket.off(OnAnalysisMessageReadyEventKey)
        } catch {}
        OnMedicationMatrixScannedEvent.register(socket, input, dispatch)
        OnLinkingRequestArrivedEvent.register(socket, input, dispatch)
        onValueTypeArrivedEvent.register(socket, input, dispatch)
        OnAnalysisMessageReadyEvent.register(socket, input, dispatch)
    }, [socket, input])

    return <>{props.children}</>
}

export default SocketController
